import { usePage } from '@inertiajs/react';
import { Flex, Text, Heading } from '@radix-ui/themes';
import { useTranslation } from 'react-i18next';
import logoUrl from '@/images/lawfi-logo.svg';
import EnvironmentBadge from '@/components/EnvironmentBadge';
import Page from '@/components/Page';
import cn from '@/lib/cn';

export default function LandingLayout({ children }) {
  const { props } = usePage();
  const { firm, logo_blob_path } = props;
  const { t } = useTranslation();

  return (
    <div className="h-full bg-gray-50">
      <Flex className="fixed m-2 right-0" justify="center">
        <EnvironmentBadge />
      </Flex>

      <div className="m-auto max-w-2xl pb-10 pt-5">
        <Page.Container className="mx-0 mt-0 sm:mt-5 lg:mx-auto">
          <Page.Content
            className={cn('md:min-w-[600px]', { 'mt-0 pt-0': logo_blob_path })}
            gap="6"
          >
            {logo_blob_path ? (
              <Flex
                justify="center"
                className="py-7 -px-5 -mt-5 sm:-mt-10 -mx-5 sm:-mx-10 sm:rounded-t-md"
                style={{ backgroundColor: firm.theme.logo_header_bg_color }}
              >
                <img
                  src={logo_blob_path}
                  className="max-w-80 max-h-40"
                  alt={firm.name}
                />
              </Flex>
            ) : (
              <Heading className="text-center">{firm.name}</Heading>
            )}

            {children}
          </Page.Content>

          <Flex justify="center" align="center" gap="2" mt="6">
            <Text color="gray" size="1">
              {t('common.powered_by')}
            </Text>

            <img alt="LawFi" src={logoUrl} className="h-[30px]" />
          </Flex>
        </Page.Container>
      </div>
    </div>
  );
}
